export default __webpack_public_path__ + "7a6a5f69684e1b68961b8c2cfbde76f7.png";